import { render, staticRenderFns } from "./PanelMotorsVoltage.vue?vue&type=template&id=81a5703a&lang=pug&"
import script from "./PanelMotorsVoltage.vue?vue&type=script&lang=js&"
export * from "./PanelMotorsVoltage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports